<template>
  <Modal title="团队迁移" :closable="false" v-model="visible" width="360" class="my-modal" :mask-closable="false" :footer-hide="true">
    <Form v-if="visible" ref="form" :model="formData" class="page-form" label-position="top">
      <FormItem prop="id" label="迁移后的上级组织" :rules="$units.formRule.required('请选择')" class="full">
        <selectTree type="5" :isSelectGrandChild='0' :methodsParams="methodsParams" @change="changeOrg" v-model="formData.id" :isAll="true"></selectTree>
      </FormItem>
      <FormItem prop="orgId" label="迁移后所属机构" class="full">
        <selectTree1 disabled ref="selectTreeRef" type="2" v-model="formData.orgId" :isAll="true"></selectTree1>
      </FormItem>
      <FormItem prop="effectiveDate" label="生效日期" :rules="$units.formRule.objRequired('请选择')" class="full">
        <DatePicker transfer type="date" v-model="formData.effectiveDate" format="yyyy-MM-dd" placeholder="请选择" :options="dateOptions"> </DatePicker>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save" :loading="loading">确认</Button>
    </div>
  </Modal>
</template>

<script>
import dayjs from 'dayjs';
import selectTree from '@/components/system/selectTree3';
import selectTree1 from '@/components/system/selectTree3';
export default {
  components: { selectTree, selectTree1 },
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        id: '',
        orgId: '', //迁移后的机构
        parentGroupId: '', //钱以后的上级团队
        groupId: '', //当前团队Id
        effectiveDate: '' //生效时间
      },
      dataList: [],
      dateOptions: {
        disabledDate: date => {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      }
    };
  },
  watch: {},
  computed: {
    methodsParams(){
      return {
        source:2,
        filterSubGroupId:this.formData.groupId
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        delete formData.id;
        formData.effectiveDate = this.$units.formatDate(formData.effectiveDate);
        this.$http({
          type: 'POST',
          url: '/buz/organizationGroup/move',
          data: formData
        }).then(res => {
          this.$Message.success('操作成功');
          this.$emit('success');
          this.visible = false;
        });
      });
    },
    open(data) {
      console.log(data);
      data = JSON.parse(JSON.stringify(data));
      this.$set(this.formData, 'groupId', data.id);
      this.$set(this.formData, 'id', '');
      this.$set(this.formData, 'effectiveDate', '');
      this.$set(this.formData, 'orgId', '');
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields();
        this.$refs.selectTreeRef.openChange();
      });
    },

    // 获取团队列表
    changeOrg(data) {
      console.log(data);
      this.$set(this.formData, 'orgId', data.nodeType == 1 ? data.id : data.orgId);
      this.$set(this.formData, 'parentGroupId', data.nodeType == 1 ? null : data.id);
      this.$nextTick(() => {
        this.$refs.selectTreeRef.selectNode({ id: this.formData.orgId });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal /deep/ .ivu-select-item {
  font-size: 12px !important;
}
</style>